export const patientFormTranslatedStrings = {
  firstName: {
    id: 'patientForm.firstName',
    defaultMessage: 'First Name'
  },
  givenName: {
    id: 'patientForm.givenName',
    defaultMessage: 'Given Name'
  },
  lastName: {
    id: 'patientForm.lastName',
    defaultMessage: 'Last Name'
  },
  middleInitial: {
    id: 'patientForm.middleInitial',
    defaultMessage: 'MI'
  },
  gender: {
    id: 'patientForm.gender',
    defaultMessage: 'Gender'
  },
  genderAtBirth: {
    id: 'patientForm.genderAtBirth',
    defaultMessage: 'Gender at birth'
  },
  dateOfBirth: {
    id: 'patientForm.dateOfBirth',
    defaultMessage: 'Date Of Birth'
  },
  chartNumber: {
    id: 'patientForm.chartNumber',
    defaultMessage: 'Chart Number'
  },
  zipCode: {
    id: 'patientForm.zipCode',
    defaultMessage: 'Zip Code #'
  },
  zipCodeErrorName: {
    id: 'patientForm.zipCodeErrorName',
    defaultMessage: 'Patient zip code'
  },
  maleOption: {
    id: 'patientForm.gender.maleOption',
    defaultMessage: 'Male'
  },
  femaleOption: {
    id: 'patientForm.gender.femaleOption',
    defaultMessage: 'Female'
  },
  buttonUpdate: {
    id: 'patientForm.buttons.update',
    defaultMessage: 'Update'
  },
  buttonConfirm: {
    id: 'patientForm.buttons.confirm',
    defaultMessage: 'Confirm'
  },
  buttonAdd: {
    id: 'patientForm.buttons.add',
    defaultMessage: 'Add'
  },
  buttonCancel: {
    id: 'patientForm.buttons.cancel',
    defaultMessage: 'Cancel'
  },
  buttonOk: {
    id: 'patientForm.buttons.ok',
    defaultMessage: 'OK'
  },
  checkboxDontShowAgain: {
    id: 'patientForm.checkbox.dontShowAgain',
    defaultMessage: 'Don\'t show me this again'
  },
  headerEdit: {
    id: 'patientForm.headers.edit',
    defaultMessage: 'Edit Patient'
  },
  headerEditDisabled: {
    id: 'patientForm.headers.editDisabled',
    defaultMessage: 'Patient Details'
  },
  headerNew: {
    id: 'patientForm.headers.new',
    defaultMessage: 'New Patient'
  },
  conflictPopupMessage: {
    id: 'patientForm.conflictPopupMessage',
    defaultMessage: 'A patient with the same details already exists:'
  },
  conflictPopupQuestion: {
    id: 'patientForm.conflictPopupQuestion',
    defaultMessage: 'Is this the same patient?'
  },
  female: {
    id: 'patientForm.female',
    defaultMessage: 'Female'
  },
  fullName: {
    id: 'patientForm.fullName',
    defaultMessage: 'Full Name'
  },
  male: {
    id: 'patientForm.male',
    defaultMessage: 'Male'
  },
  conflictHeader: {
    id: 'patientForm.conflictHeader',
    defaultMessage: 'A patient with the same details already exists:'
  },
  yes: {
    id: 'patientForm.yes',
    defaultMessage: 'Yes'
  },
  no: {
    id: 'patientForm.no',
    defaultMessage: 'No'
  },
  errorGeneralHeader: {
    id: 'patientForm.errorGeneralHeader',
    defaultMessage: 'Warning'
  },
  errorGeneralMessageNew: {
    id: 'patientForm.errorGeneralMessageNew',
    defaultMessage: 'Patient creation failed. Please try again.'
  },
  errorGeneralMessageEdit: {
    id: 'patientForm.errorGeneralMessageEdit',
    defaultMessage: 'Failed to update patient details. Please try again.'
  },
  question: {
    id: 'patientForm.question',
    defaultMessage: 'Question'
  },
  buttonClear: {
    id: 'patientForm.buttons.clear',
    defaultMessage: 'Clear'
  },
  clearPatientDataConfirmation:{
    id: 'patientForm.clearPatientDataConfirmation',
    defaultMessage: 'This action will clear all the field under patient section in RX. Are you sure you want to clear them?'
  },
  clickHere: {
    id: 'patientForm.conflict.clickHere',
    defaultMessage: 'Click here'
  },
  loadExistingPatientOrCreateNew: {
    id: 'patientForm.conflict.loadExistingPatientOrCreateNew',
    defaultMessage: 'to load the existing patient or edit the highlighted fields to create a new patient'
  },
  loadExistingPatientLink:{
    id:'patientForm.conflict.loadExistingPatientLink',
    defaultMessage:'Load existing patient'
  },
  loadExistingPatientMessage:{
    id:'patientForm.conflict.loadExistingPatientMessage',
    defaultMessage:'or edit highlighted fields above to create a new patient'
  },
  confirmation:{
    id:'patientForm.confirmation',
    defaultMessage:'Confirmation'
  },
  patient:{
    id:'patientForm.patient',
    defaultMessage:'Patient'
  }
};
